/**
 * The list of permissions available for the Hoya Learning Center.
 */
const HoyaLearningCenterPermissions = {
    READ_COURSE_SEGMENTATION: 'read-course-segmentation',
    EDIT_COURSE_SEGMENTATION: 'edit-course-segmentation',
};

export default HoyaLearningCenterPermissions;
